import { denormalize } from 'normalizr';

import * as schemas from 'schemas';

export const isFetchingFaqCategories = state =>
  state.faq.isFetching || !state.faq.isFetched;

export const getFaqCategories = state =>
  denormalize(state.faq.categoryIds, [schemas.faqCategory], state.content);

export const getFaqQuestion = (state, id) =>
  denormalize(id, schemas.faqQuestion, state.content);



// WEBPACK FOOTER //
// ./src/store/faq/selectors.js